module.exports = __webpack_public_path__ + "img/partnerzy-09_ongeo_services.4a00bdc0.svg";